module.exports = "<router-outlet></router-outlet>\r\n<app-loader></app-loader>"